var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card dash-card comment-item"},[_vm._v("\n   "+_vm._s(_vm.questionText)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }